<div class="call-context-details">
  <div class="assistant-context-tab">
    @if (loading$ | async) {
      <div class="loading-spinner">
        <i [nimbusIcon]="ICONS.SPINNER" [iconWeight]="IconWeight.Regular"></i>
      </div>
    } @else {
      @if (!task?.contextData?.length) {
        <div class="info-nothingToDisplay">
          {{ TranslationKeys.AssistantContextNoDataToDisplay | translate }}
        </div>
      }
      <div class="action-buttons">
        @if (task?.contextData?.length > 0) {
          <button class="outline icon" (click)="copyAll()" nimbusPrimaryIconButton>
            <i [nimbusIcon]="ICONS.COPY" [iconWeight]="IconWeight.Regular">
              <nimbus-tooltip [text]="TranslationKeys.GeneralCopy | translate" [position]="'left'"></nimbus-tooltip>
            </i>
          </button>
        }
        <button class="outline icon" (click)="openMySessions()" nimbusPrimaryIconButton>
          <i [nimbusIcon]="ICONS.EXTERNAL_LINK" [iconWeight]="IconWeight.Regular">
            <nimbus-tooltip [text]="TranslationKeys.AssistantContextOpenSessionDashboard | translate" [position]="'left'"></nimbus-tooltip>
          </i>
        </button>
      </div>
      @for (x of task?.contextData; track $index) {
        @if (!x.isUrl) {
          <div class="entry">
            <span class="key">{{ x.key | translate }}:</span><br />
            <span class="value text-no-wrap tooltip-container">{{ x.value }} <nimbus-tooltip [text]="x.value"></nimbus-tooltip></span>
            <button class="outline icon" (click)="copyValue(x.value)" nimbusPrimaryIconButton>
              <i [nimbusIcon]="ICONS.COPY" [iconWeight]="IconWeight.Regular">
                <nimbus-tooltip [text]="TranslationKeys.GeneralCopy | translate" [position]="'left'"></nimbus-tooltip>
              </i>
            </button>
          </div>
        } @else {
          <div class="entry">
            <span class="key">{{ x.key | translate }}:</span><br />
            <a class="value text-no-wrap tooltip-container" (click)="openUrl(x.value)"
              >{{ x.value }}
              <nimbus-tooltip [text]="x.value"></nimbus-tooltip>
            </a>
            <button class="outline icon" (click)="copyValue(x.value)" nimbusPrimaryIconButton>
              <i [nimbusIcon]="ICONS.COPY" [iconWeight]="IconWeight.Regular">
                <nimbus-tooltip [text]="TranslationKeys.GeneralCopy | translate" [position]="'left'"></nimbus-tooltip>
              </i>
            </button>
          </div>
        }
      }
    }
  </div>
</div>
